import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Spinner } from 'react-bootstrap';
import { SparkleButton } from '../SparkleEffect';

/**
 * Shared primary CTA used by checkout flows.
 */
export default function CheckoutCTAButton({
  trialDays = null,
  processing = false,
  disabled = false,
  className = '',
  processingLabel = '',
  label,
  sparkle = true,
}) {
  const buttonLabel =
    label ||
    (typeof trialDays === 'number'
      ? `✨ Start Your ${trialDays}-Day FREE Trial`
      : 'Complete Purchase');
  const effectiveProcessingLabel =
    processingLabel ||
    (typeof trialDays === 'number' ? 'Processing Your Trial...' : 'Processing your payment…');

  const ButtonComponent = sparkle ? SparkleButton : 'button';

  return (
    <ButtonComponent
      type="submit"
      disabled={disabled || processing}
      className={classNames('checkout-submit-btn', className)}
    >
      {processing ? (
        <>
          <Spinner animation="border" size="sm" className="me-2" />
          {effectiveProcessingLabel}
        </>
      ) : (
        buttonLabel
      )}
    </ButtonComponent>
  );
}

CheckoutCTAButton.propTypes = {
  trialDays: PropTypes.number,
  processing: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  processingLabel: PropTypes.string,
  label: PropTypes.string,
  sparkle: PropTypes.bool,
};
